import { LandingRewards } from './../../../core/domain/landing-rewards/models/landing-rewards-data.model';
import { BreakpointService } from '@/common/services/breakpoint/breakpoint.service';
import { CurrentReservationService } from '@/common/services/reservation/current';
import { UrlService } from '@/common/services/url/url.service';
import { ValidationService } from '@/common/services/validation/validation.service';
import { GetLandingRewardsUseCase } from '@/core/domain/landing-rewards/usecases/getLandingRewards.usecase';
import { PromotionDetailsResponse } from '@/core/domain/promotion-details/models/promotion-details.model';
import { GetPromotionDetailsUseCase } from '@/core/domain/promotion-details/usecases/getPromotionsDetails.usecase';
import { environment } from '@/env/environment';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, of, throwError } from 'rxjs';
import { LandingRewardsResponse } from '../../../core/domain/landing-rewards/models/landing-rewards.model';

@Component({
    selector: 'fe-alamo-rewards',
    templateUrl: './alamo-rewards.component.html',
    styleUrls: ['./alamo-rewards.component.scss'],
})
export class AlamoRewardsComponent implements OnInit {
    public loadingBtnOffers = true;
    public formInfoOffers!: FormGroup;
    public urlActionInfo = environment.alamoRewards;
    @ViewChild('formInfoOffersElement') formInfoOffersElement!: ElementRef;
    @ViewChild('formElement') formElement!: ElementRef;
    breadcrumbs = [
        {
            label: 'fe_alamo-rewards_breadcrumb',
            url: 'check-your-reservation',
        },
    ];
    public discountCode: string | null = null;

    public landingRewardsResponse!: LandingRewardsResponse | null;

    public origin: 'promotions' | 'landing' = 'promotions';
    public backgroundUrl?: string | null = null;

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly validation: ValidationService,
        public url: UrlService,
        private readonly getLandingRewardsUseCase: GetLandingRewardsUseCase,
        private readonly meta: Meta,
        private readonly titleService: Title,
        public breakpoint: BreakpointService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        public reservation: CurrentReservationService,
    ) {}
    ngOnInit(): void {
        this.initForm();
        this.getLandingRewards();
    }

    private initForm(): void {
        const formGroup = {
            names: ['', Validators.compose([Validators.required])],
            lastName: ['', Validators.compose([Validators.required])],
            email: [
                '',
                Validators.compose([
                    Validators.required,
                    this.validation.validEmail,
                ]),
            ],
            phone: ['', Validators.compose([Validators.required])],
        };
        this.formInfoOffers = this.formBuilder.group(formGroup);
        this.loadingBtnOffers = false;
    }
    public onClickSendInfoOffers(): void {
        this.formInfoOffers.markAllAsTouched();
        this.loadingBtnOffers = true;
        if (!this.formInfoOffers.valid) {
            return;
        }
        this.formElement.nativeElement.submit();
    }

    public getLandingRewards(): void {
        this.route.data.subscribe(() => {
            const getLandingRewards = this.getLandingRewardsUseCase.execute();

            getLandingRewards
                .pipe(
                    catchError((error) => {
                        return throwError(() => error);
                    }),
                )
                .subscribe((landigRewards) => {
                    this.landingRewardsResponse = landigRewards;
                    if (this.isBackground()) {
                        this.backgroundUrl = this.breakpoint.isMobile()
                            ? this.landingRewardsResponse?.data?.landingRewards
                                  .backgroundMobile
                            : this.landingRewardsResponse?.data?.landingRewards
                                  .background;
                    }
                });
        });
    }

    public isBackground(): boolean {
        const landingRewards =
            this.landingRewardsResponse?.data?.landingRewards;
        const isBackground = !!landingRewards?.isBackground;
        const isBackgroundMobile = !!landingRewards?.isBackgroundMobile;
        return (
            (isBackground && !this.breakpoint.isMobile()) ||
            (isBackgroundMobile && this.breakpoint.isMobile())
        );
    }
}
